const WEB_MOBILE_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export function getIsMobile() {
  const userAgent = typeof navigator !== 'undefined' && (navigator.userAgent || navigator.vendor);
  return !!userAgent && WEB_MOBILE_REGEX.test(userAgent);
}
